import { faLongArrowAltRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "react";
import { Container } from "reactstrap";
import shared from "../../../shared";
import CollabseDetail from "./collabseDetail";
import httpClient from "../../../httpClient";
import VolLine from "./volLine";

class VolCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flights: [],
    };
  }
  async componentDidMount() {
    const fls = await httpClient.getDetailVol(this.props.vol.token);
    this.setState({
      flights: fls.flights,
    });
  }

  lines(el){
    let line = [];
    let j = 0
    let esc;
    for (let i = 0; i < el.volLine.length*2; i=i+2) {
      if(typeof this.props.escale[j] === 'undefined'){
        esc = " "
      }
      else esc= this.props.escale[j]

      line.push(
        <>
        <VolLine
          vol={el.vol}
          dates={[el.dates[i], el.dates[i + 1]]}
          horaires={[el.horaires[i], el.horaires[i + 1]]}
          departCode={el.codes[j]}
          arriveCode={el.codes[j+1]}
          citiesName={[this.props.citiesName[i], this.props.citiesName[i+1]]}
          escalejd={esc}
          duree={el.volLine[j].duree}
          flight_no={el.volLine[j].flight_no}
          volclass={el.volLine[j].vol_class}
        />
        <br />
        </>
      );
      j++
    }
    return line;
  }

  render() {
    const {
      arrive,
      vol,
    } = this.props;
    console.log(this.props);
    const flts = this.state.flights;
    let vOv = true;
    var itenAller = [];
    var itenRetour = [];
    flts.map((i, j) => {
      if (vOv) {
        itenAller.push(i);
      } else itenRetour.push(i);
      if (i.dst_name.toLowerCase() === arrive.toLowerCase()) {
        vOv = false;
      }
    });

    return (
      <>
        <div className="card mb-2 d-flex justify-content-between shad-vol">
          <div className="card-body py-2 ">
            <div className="row d-flex pt-3">
              <div className="col-10">
              {/* <VolLine
          vol={vol}
          dates={[dates[0], dates[1]]}
          horaires={[horaires[0], horaires[1]]}
          depart={depart}
          departCode={departCode}
          arrive={arrive}
          arriveCode={arriveCode}
          escale={escaleAller}
          citiesName={[this.props.citiesName[0], this.props.citiesName[1]]}
        />
        <br />

                {!rtrn && (
                  <VolLine
                    vol={vol}
                    dates={[dates[2], dates[3]]}
                    horaires={[horaires[2], horaires[3]]}
                    depart={depart}
                    departCode={departCode}
                    arrive={arrive}
                    arriveCode={arriveCode}
                    escale={escaleAller}
                    citiesName={[this.props.citiesName[2], this.props.citiesName[3]]}
                    />
                )} */}
                <br />
                                {this.lines(this.props)}
                <br />
              </div>
              <div className="col-2 d-flex flex-column justify-content-center">
                <h5
                  className="card-title mb-4 d-flex justify-content-end"
                  style={{ fontWeight: "bold", fontSize: "22px" }}
                >
                  {vol.total} {vol.currency}
                </h5>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <div className="col-4 px-0"></div>
              <div
                className="btn d-flex flex-column align-items-center mt-3 col-4 px-0"
                data-toggle="collapse"
                data-target={`#collapse${this.props.childKey.slice(
                  this.props.childKey.length - 5,
                  this.props.childKey.length - 3
                )}`}
                aria-expanded="false"
                aria-controls={`collapse${this.props.childKey.slice(
                  this.props.childKey.length - 5,
                  this.props.childKey.length - 3
                )}`}
              >
                <span> Plus de Details</span>
                <img
                  className="mt-1"
                  src="/imgs/navebar/downArrow.svg"
                  alt="parcouri"
                />
              </div>
              <div className="d-flex col-4 px-0 justify-content-end">
                <a
                  onClick={() => shared.openInNewTab(`${vol.bookingLink}`)}
                  className="btn btn-primary mt-3"
                >
                  <span className="px-2">Sélectionner</span>
                </a>
              </div>
            </div>
            <div
              class="collapse"
              id={`collapse${this.props.childKey.slice(
                this.props.childKey.length - 5,
                this.props.childKey.length - 3
              )}`}
            >
              <div className="card mt-2">
                <CollabseDetail aller={itenAller} retour={itenRetour} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default VolCard;
